import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import React from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';
import { useFeaturesContext } from '../features-context/features-context';

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var QuickFindSearchResultWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: ", ";\n\tpadding: ", ";\n"])), "var(--ds-space-025, 2px)", "var(--ds-space-100, 8px)");
export var SearchResultWrapper = function SearchResultWrapper(_ref) {
  var children = _ref.children;
  var _useFeaturesContext = useFeaturesContext(),
    quickFind = _useFeaturesContext.quickFind;
  return quickFind !== null && quickFind !== void 0 && quickFind.enabled ? /*#__PURE__*/React.createElement(QuickFindSearchResultWrapper, null, children) : /*#__PURE__*/React.createElement(React.Fragment, null, children);
};